<template>
  <MagicOrgChartDemo :org=org2 :departments=departments :peopleForCharts=peopleForChart :functions="{addToAvailablePeople, removeFromAvailablePeople, toggleHorizontal, setPerson, addReport, toggleMove, selectMoveDestination, setExpanded}" :moveInProgress=moveInProgress />
</template>

<script>
// import DynamicOrgChart from '../components/DynamicOrgChart';
import MagicOrgChartDemo from '../components/MagicOrgChartDemo';
import { v4 as uuidv4 } from 'uuid';
import * as _ from 'lodash';

export default {
  components: {
    //DynamicOrgChart,
    MagicOrgChartDemo
  },
  computed: {
      peopleForChart: function() {
        let people = []
        this.org2.chart.forEach((chart, i) => {
          people.push([...this.availablePeople[i], ...this.getPeopleFromChart(chart, [i])]);
        })
        return people
      }
  },
  methods: {
      removeFromAvailablePeople: function(id, selectedChartIndex) {
        let chartToUpdate = [...this.availablePeople[selectedChartIndex]]
        _.remove(chartToUpdate, function(n) {
            return n.id == id;
        });
        this.availablePeople[selectedChartIndex] = chartToUpdate
      },
      addToAvailablePeople: function(person, selectedChartIndex) {
        let chartToUpdate = this.availablePeople[selectedChartIndex]
        chartToUpdate.push({
          ...person, 
          displayName: `${person.firstName} ${person.lastName}`
        })
        this.availablePeople[selectedChartIndex] = chartToUpdate
      },
      getPeopleFromChart: function(chart, indexArray) {
          let people = []
          if (chart.person) {
            people.push(
                {
                    ...chart.person,
                    displayName: `${chart.person.firstName} ${chart.person.lastName}`,
                    indexArray
                })
          }

          if (chart.reports && chart.reports.length) {
              chart.reports.forEach((report, i) => {
                // console.log('==========')
                // console.log(report)
                // console.log(chart)
                // console.log('==========')
                people.push(...this.getPeopleFromChart(report, [...indexArray, i]))
              })
          }
          return people;
      },
      generateUUID: function() {
          return uuidv4();
      },
      findPerson(ia) {
        let indexArray = [...ia]
        let chartIndex = indexArray.shift()
        let chart = this.org2.chart[chartIndex]
        indexArray.forEach(index => {
            chart = chart.reports[index]
        })
        return chart;
      },
      toggleHorizontal(indexArray) {
        let person = this.findPerson(indexArray)
        person.reportsHorizontal = !person.reportsHorizontal
      },
      setExpanded(indexArray, isExpanded) {
        let person = this.findPerson(indexArray)
        person.expanded = isExpanded
      },
      setPerson(indexArray, newPerson) {
        let person = this.findPerson(indexArray)
        let chartIndex = [...indexArray].shift()
        if (newPerson && person && person.person) {
            person.person = {...person.person, indexArray: null}
          this.availablePeople[chartIndex] = [
            {
              ...person.person, 
              displayName: `${person.person.firstName} ${person.person.lastName}`
            },
           ...this.availablePeople[chartIndex]]
        }
        person.person = newPerson
      },
      toggleMove(indexArray) {
          if (this.moveInProgress && _.isEqual(this.moveInProgress, indexArray)) {
              this.moveInProgress = false;
          } else {
            this.moveInProgress = indexArray;
          }
      },
      selectMoveDestination(ia) {
          if (this.moveInProgress) {
            //Get the person to move
            let indexArray = [...this.moveInProgress]
            let chartIndex = indexArray.shift()
            let finalIndex = indexArray.pop()
            let chart = this.org2.chart[chartIndex]
            indexArray.forEach(index => {
                chart = chart.reports[index]
            })
            let reportToMove = chart.reports[finalIndex];
            //Actually move them
            let person = this.findPerson(ia)
            person.reports.push(reportToMove)
            //make sure to remove the old after adding the new to the end :)
            chart.reports.splice(finalIndex, 1);
            this.moveInProgress = false;
          }
        return
      },
      addReport(indexArray, report) {
        let person = this.findPerson(indexArray)
        if (!person.reports) {
          person.reports = [];
        }
        person.reports.push(report);
      },
  },
  data: function() {
      return {
        departments: [
          {name: 'Engineering', id: this.generateUUID(), color: 'rgba(200,0,0,0.2)'},
          {name: 'Marketing', id: this.generateUUID(), color: 'rgba(211, 84, 0, 0.2)'},
          {name: 'Operations', id: this.generateUUID(), color: 'rgba(0,0,200,0.2)'},
          {name: 'Executive', id: this.generateUUID(), color: 'rgba(249, 191, 59, 1)'},
        ],
        availablePeople: [[], [], [], []],
        moveInProgress: false,
        org2: {
          name: 'My Company Rules LLC',
          size: 100,
          chart: [
             {
                jobTitle: 'Founder',
                id: this.generateUUID(),
                department: 'Executive',
                budgetedHours: '40+',
                salary: '55,000',
                person: {
                    id: this.generateUUID(),
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                expanded: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '40,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Engineering Intern',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '18/hr',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'David',
                            lastName: 'Harp',
                            hireDate: new Date('2001-07-19'),
                            imageUrl: require('../assets/DavidHarp.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }, {
                        jobTitle: 'Engineering Intern',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '18/hr',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Lisa',
                            lastName: 'Harp',
                            hireDate: new Date('2001-07-19'),
                            imageUrl: require('../assets/LisaHarp.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '40,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rebecca',
                            lastName: 'August',
                            hireDate: new Date('2001-06-15'),
                            imageUrl: require('../assets/RebeccaAugust.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Social Media Marketing Intern',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '14/hr',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    }

                ]
              },
              {
                jobTitle: 'Founder',
                id: this.generateUUID(),
                department: 'Executive',
                budgetedHours: '40+',
                salary: '120,000',
                person: {
                    id: this.generateUUID(),
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                expanded: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '80,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Senior Software Engineer',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '60,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rachel',
                            lastName: 'Nelson',
                            hireDate: new Date('2004-01-09'),
                            imageUrl: require('../assets/RachelNelson.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    },{
                        jobTitle: 'Junior Software Engineer',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '45,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rodney',
                            lastName: 'Applewood',
                            hireDate: new Date('2004-02-25'),
                            imageUrl: require('../assets/RodneyApplewood.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '80,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rebecca',
                            lastName: 'August',
                            hireDate: new Date('2001-06-15'),
                            imageUrl: require('../assets/RebeccaAugust.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Social Media Marketer',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '41,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    }

                ]
              },
              {
                jobTitle: 'Founder',
                id: this.generateUUID(),
                department: 'Executive',
                budgetedHours: '40+',
                salary: '120,000',
                person: {
                    id: this.generateUUID(),
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                expanded: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '180,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Merchant App Lead',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rachel',
                            lastName: 'Nelson',
                            hireDate: new Date('2004-01-09'),
                            imageUrl: require('../assets/RachelNelson.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    },{
                        jobTitle: 'Software Engineer',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '75,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rodney',
                            lastName: 'Applewood',
                            hireDate: new Date('2004-02-25'),
                            imageUrl: require('../assets/RodneyApplewood.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '130,000',
                        person: null,
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Social Media Marketer',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '55,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'COO',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Lucas',
                            lastName: 'Petrol',
                            hireDate: new Date('2011-11-25'),
                            imageUrl: require('../assets/LucasPetrol.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'HR Generalist',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Clay',
                            lastName: 'Zunfer',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/ClayZunfer.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    },
                    {
                        jobTitle: 'Technical Recruiter',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000 + commission',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Emily',
                            lastName: 'Mandin',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/EmilyMandin.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    }

                ]
              },
           {
                jobTitle: 'Founder',
                id: this.generateUUID(),
                department: 'Executive',
                budgetedHours: '40+',
                salary: '120,000',
                person: {
                    id: this.generateUUID(),
                    firstName: 'Tom',
                    hireDate: new Date('2001-03-14'),
                    lastName: 'McGee',
                    imageUrl: require('../assets/TomMcGee.jpg')
                },
                reportsHorizontal: true,
                expanded: true,
                reports: [ 
                    {
                        jobTitle: 'CTO',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '180,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Megan',
                            lastName: 'Runn',
                            hireDate: new Date('2001-05-12'),
                            imageUrl: require('../assets/MeganRunn.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Internal Apps Team Lead',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Tommy',
                            lastName: 'Applewood',
                            hireDate: new Date('2004-02-25'),
                            imageUrl: require('../assets/RodneyApplewood.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    },{
                        jobTitle: 'Merchant App Team Lead',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rachel',
                            lastName: 'Nelson',
                            hireDate: new Date('2004-01-09'),
                            imageUrl: require('../assets/RachelNelson.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Software Engineer',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '60,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'David',
                            lastName: 'Harp',
                            hireDate: new Date('2016-05-11'),
                            imageUrl: require('../assets/DavidHarp.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }, {
                        jobTitle: 'Senior Software Engineer',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40',
                        salary: '100,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Lisa',
                            lastName: 'Harp',
                            hireDate: new Date('2005-03-13'),
                            imageUrl: require('../assets/LisaHarp.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    },{
                        jobTitle: 'Internal Apps Team Lead',
                        id: this.generateUUID(),
                        department: 'Engineering',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rodney',
                            lastName: 'Applewood',
                            hireDate: new Date('2004-02-25'),
                            imageUrl: require('../assets/RodneyApplewood.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'CMO',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40+',
                        salary: '150,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Molly',
                            lastName: 'Rapture',
                            hireDate: new Date('2018-01-15'),
                            imageUrl: require('../assets/MollyRapture.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Social Media Marketer',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '65,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Kyle',
                            lastName: 'Ikoma',
                            hireDate: new Date('2001-11-03'),
                            imageUrl: require('../assets/KyleIkoma.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    },
                    {
                        jobTitle: 'Senior Marketer',
                        id: this.generateUUID(),
                        department: 'Marketing',
                        budgetedHours: '40',
                        salary: '85,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Rebecca',
                            lastName: 'August',
                            hireDate: new Date('2017-12-05'),
                            imageUrl: require('../assets/RebeccaAugust.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [],
                    }]
                    },
                    {
                        jobTitle: 'COO',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40+',
                        salary: '120,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Lucas',
                            lastName: 'Petrol',
                            hireDate: new Date('2011-11-25'),
                            imageUrl: require('../assets/LucasPetrol.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'HR Generalist',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Clay',
                            lastName: 'Zunfer',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/ClayZunfer.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: [{
                        jobTitle: 'Junior Technical Recruiter',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '30,000 + commission',
                        person: null,
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }, {
                        jobTitle: 'Junior Technical Recruiter',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '30,000 + commission',
                        person: null,
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }, {
                        jobTitle: 'Junior Technical Recruiter',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '30,000 + commission',
                        person: null,
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    },
                    {
                        jobTitle: 'Lead Technical Recruiter',
                        id: this.generateUUID(),
                        department: 'Operations',
                        budgetedHours: '40',
                        salary: '55,000 + commission',
                        person: {
                            id: this.generateUUID(),
                            firstName: 'Emily',
                            lastName: 'Mandin',
                            hireDate: new Date('2012-04-22'),
                            imageUrl: require('../assets/EmilyMandin.jpg')
                        },
                        reportsHorizontal: true,
                        expanded: true,
                        reports: []
                    }]
                    }

                ]
              }
          ]    
      }
      }
  }
};
</script>
